///<reference path='../../typings/index.d.ts' />
///<reference path='../animation/animation.ts' />
///<reference path='pixilayer.ts' />

module agi.expressions.card.layer {

    import Event = agi.expressions.event.Event;
    import AssetManifest = agi.expressions.card.manifest.AssetManifest;
    import AnimatedItem = agi.expressions.card.animation.AnimatedItem;
    import MovieClip = PIXI.extras.MovieClip;

    export class Reveal extends PixiLayer{
        private renderer:PIXI.WebGLRenderer|PIXI.CanvasRenderer;
        private assetManifest:AssetManifest;
        private globalScale:number = 0.7333333;
        private itemsContainer:PIXI.Container;
        private items:Array<AnimatedItem> = [];
        private butterflyGlowButton:AnimatedItem;
        private userPrevLocationX:number = 0;
        private userPrevLocationY:number = 0;
        private velocity:number = 0;
        private restTriggerRadius:number = 100;
        private onDownBind:any;
        private onMoveBind:any;
        private onUpBind:any;
        private reversing:boolean = false;
        private animatedItemReversedCount:number = 0;
        private animatedItemPlayed:number = 0;

        constructor(){
            super();
        }

        public init(options:SceneOptions){
            this.renderer = options.renderer;         
            this.assetManifest = options.assetManifest;
            this.itemsContainer = new PIXI.Container();

            this.addItems();
            this.addChild(this.itemsContainer);

            this.interactive = true;
            this.buttonMode = true;

            this.eventBus.addEventListener("glowOn", this.glowOnHandler.bind(this));
            this.eventBus.addEventListener("glowOff", this.glowOffHandler.bind(this));

            this.onDownBind = this.onDown.bind(this);
            this.onMoveBind = this.onMove.bind(this);
            this.onUpBind = this.onUp.bind(this);
            this.eventBus.addEventListener("userInteractionStarted", this.onDownBind);
            this.eventBus.addEventListener("userMove", this.onMoveBind);
            this.eventBus.addEventListener("userInteractionEnded", this.onUpBind);
            this.eventBus.addEventListener("animatedItemFinishedReset", this.animatedItemFinishedReverse.bind(this));
            this.eventBus.addEventListener("animatedItemResetStart", this.animatedItemResetStart.bind(this));
        }

        public reset(){
            if (!this.reversing) {
                this.reversing = true;
                this.eventBus.removeEventListener("userInteractionStarted", this.onDownBind);
                this.eventBus.removeEventListener("userMove", this.onMoveBind);
                this.eventBus.removeEventListener("userInteractionEnded", this.onUpBind);
                this.visible = true;
                this.resetLeaveAnimation();
                this.changeItemsVisible(true);
            }
        }

        public animate(deltaTime?:number){
            if(!this.isPlaying){
                this.isPlaying=true;
            }else{
                for (var i = 0, len = this.items.length; i < len; i++) {
                    this.items[i].animate(deltaTime);
                }
            }
        }

        protected animatedItemResetStart(event:Event) {
            this.animatedItemPlayed++;
        }

        protected animatedItemFinishedReverse(event:Event) {
            this.animatedItemReversedCount++;
            if (this.animatedItemReversedCount === this.animatedItemPlayed){
                this.finishedReset();
            }
        }

        protected finishedReset() {
            this.onDownBind =  this.onDown.bind(this);
            this.onMoveBind =  this.onMove.bind(this);
            this.onUpBind =  this.onUp.bind(this);
            this.eventBus.addEventListener("userInteractionStarted", this.onDownBind);
            this.eventBus.addEventListener("userMove", this.onMoveBind);
            this.eventBus.addEventListener("userInteractionEnded", this.onUpBind);
            this.reversing = false;
            this.animatedItemReversedCount = 0;
            this.animatedItemPlayed = 0;
            var revealResetEvent:Event = new Event("revealReset", this);
            this.eventBus.dispatchEvent(revealResetEvent);
        }

        protected getRandomLeaveTweenData():any{
            var nTweens:number = this.assetManifest.leaveTweensData.length;
            return this.assetManifest.leaveTweensData[Math.floor(Math.random()*nTweens)];
        }

        protected addItem(item:AnimatedItem,x:number,y:number,sc:number,rot:number):AnimatedItem{
            item.setPosition(x*this.globalScale, y*this.globalScale);
            item.setScale(sc*this.globalScale);
            rot*=Math.PI/180;
            item.setRotation(rot);
            item.leaveTweenStarted.add(()=>{
                //One in 5 will have a sound effect;
                var randNumber:number = Math.floor(Math.random() * 5) + 1;
                if (this.items.length === 0 || randNumber > 4){
                    var sfxEvent:any = new Event("playSFX", this);
                    sfxEvent.sfx = "sfx1";
                    this.eventBus.dispatchEvent(sfxEvent);
                }
            });
            this.itemsContainer.addChild(item.container);            
            this.items.push(item);
            return item;
        }

        protected addItems():void{
            var purpleData:any = this.assetManifest.butterflyReveal.itemAnimationStatesTextureData.purple;
            var purplePositioningData:any = this.assetManifest.butterflyReveal.positioningData.purple;
            var orangeData:any = this.assetManifest.butterflyReveal.itemAnimationStatesTextureData.orange;
            var orangePositioningData:any = this.assetManifest.butterflyReveal.positioningData.orange;
            var butterflyButtonData:any = this.assetManifest.butterflyReveal.itemAnimationStatesTextureData.purple;
            var butterflyButtonPositionData:any = this.assetManifest.butterflyReveal.positioningData.butterflyButton;

            this.iterateAndAddItems(purpleData, purplePositioningData);
            this.iterateAndAddItems(orangeData, orangePositioningData);
            this.iterateAndAddItems(butterflyButtonData, butterflyButtonPositionData);
           
            this.butterflyGlowButton = this.items[this.items.length-1];
            this.butterflyGlowButton.glowMC.visible=false;  
            this.butterflyGlowButton.glowMC.alpha=0;       
            this.butterflyGlowButton.idleModifier=0;
            this.butterflyGlowButton.idleDelay=100;              
        }

        protected iterateAndAddItems(textureData, positionData){
             for (var i = 0; i < positionData.length; ++i){
                this.addItem(new AnimatedItem(textureData, this.getRandomLeaveTweenData()), 
                    positionData[i][0], positionData[i][1],
                    positionData[i][2], positionData[i][3]
                );
            }
        }

        protected resetLeaveAnimation():void{
            for (var i = this.items.length-1; i >= 0; i--) {
                this.items[i].resetLeaveAnimation();
            }
            //Last one returns to the top of the child list
            this.itemsContainer.setChildIndex(this.items[this.items.length-1].container,
                this.itemsContainer.children.length-1);
        }

        protected changeItemsVisible(val:boolean):void{
            for (var i = 0, len = this.items.length; i < len; i++) {
                this.items[i].container.visible = val;
            }
        }

        protected findItemsInCircle(ctr:PIXI.Container, center:PIXI.Point):AnimatedItem[]{
            var foundItems:AnimatedItem[] = [];
            var rangeCircle = new PIXI.Circle(center.x, center.y, this.restTriggerRadius);
            var item:AnimatedItem;
            for (var i = 0, len = this.items.length; i < len; i++) {
                item = this.items[i];
                if(rangeCircle.contains(item.container.x, item.container.y)){
                    foundItems.push(item);
                }
            }
            return foundItems;
        }

        protected glowOnHandler(event:Event) {
            this.butterflyGlowButton.glowMC.visible = true;
            TweenMax.to(this.butterflyGlowButton.glowMC.scale,0.5,{x:1.05,y:1.05,yoyo:true,repeat:-1});
            TweenLite.to(this.butterflyGlowButton.glowMC,1,{alpha:1});
        }

        protected glowOffHandler(event:Event) {
            this.butterflyGlowButton.glowMC.visible = false;
            TweenLite.killTweensOf(this.butterflyGlowButton.glowMC);
            TweenMax.killTweensOf(this.butterflyGlowButton.glowMC.scale);
        }

        protected onDown (event:any) {
            this.userPrevLocationX = event.pixi.data.getLocalPosition(this.itemsContainer).x;
            this.userPrevLocationY = event.pixi.data.getLocalPosition(this.itemsContainer).y;
        }

        protected onMove (event:any) {
            var pos = event.pixi.data.getLocalPosition(this.itemsContainer);

            //find velocity
            this.velocity=Math.sqrt(
                Math.pow((pos.x-this.userPrevLocationX),2) + 
                Math.pow((pos.y-this.userPrevLocationY),2)
            );
            this.userPrevLocationX=pos.x;
            this.userPrevLocationY=pos.y;

            var itemsInRange = this.findItemsInCircle(this.itemsContainer, pos);
            var rndRepeat = Math.ceil(Math.random()*4 + 2);
            for (var i = 0, len = itemsInRange.length; i < len; i++) {
                if(this.velocity<10){
                    //slow, just agitates
                    itemsInRange[i].doRestAnimation(rndRepeat);
                }else{
                    //fast, shoo away
                    this.itemsContainer.setChildIndex(itemsInRange[i].container,
                        this.itemsContainer.children.length-1);         
                    itemsInRange[i].doLeaveAnimation();
                }
            }
        }

        protected onUp (event:any) {
        }
    }
}
